var map = {
	"./closeBox.svg": "22e0",
	"./collection.svg": "55c9",
	"./comm_icon_gou.svg": "a2c4",
	"./copy.svg": "c0a5",
	"./down.svg": "1a4e",
	"./draw-histroy.svg": "59a8",
	"./draw-money-icon.svg": "5f25",
	"./draw-qa.svg": "733c",
	"./draw-right.svg": "2c28",
	"./draw-title.svg": "5377",
	"./draw-voice.svg": "c9ac",
	"./fb-right.svg": "9357",
	"./full-screen.svg": "6d88",
	"./icon-file.svg": "7eaa",
	"./input_icon_fb.svg": "7592",
	"./input_icon_telegram.svg": "0f54",
	"./input_icon_wechat.svg": "2c5f",
	"./input_icon_whatsapp.svg": "a491",
	"./menus.svg": "0167",
	"./mes.svg": "e556",
	"./mine-down.svg": "e1a1",
	"./mine-edit.svg": "38dc",
	"./mine-function1.svg": "a79c",
	"./mine-function10.svg": "f498",
	"./mine-function11.svg": "75ed",
	"./mine-function12.svg": "b918",
	"./mine-function13.svg": "0f9b",
	"./mine-function14.svg": "f430",
	"./mine-function15.svg": "2679",
	"./mine-function16.svg": "7cd5",
	"./mine-function17.svg": "574b",
	"./mine-function18.svg": "d337",
	"./mine-function19.svg": "4d95",
	"./mine-function2.svg": "5765",
	"./mine-function20.svg": "e54d",
	"./mine-function21.svg": "34b8",
	"./mine-function22.svg": "59c7",
	"./mine-function23.svg": "3e55",
	"./mine-function24.svg": "af8c",
	"./mine-function3.svg": "9535",
	"./mine-function4.svg": "b156",
	"./mine-function5.svg": "ad7c",
	"./mine-function6.svg": "5849",
	"./mine-function7.svg": "df85",
	"./mine-function8.svg": "a34a",
	"./mine-function9.svg": "9e45",
	"./mine-kf.svg": "d6af",
	"./mine-message.svg": "1088",
	"./mine-phone.svg": "bb1f",
	"./mute.svg": "2482",
	"./nem-sems-a.svg": "b58e",
	"./noMute.svg": "47d8",
	"./no_collection.svg": "091d",
	"./nofull-screen.svg": "8221",
	"./over_logo.svg": "9f07",
	"./play.svg": "4c1a",
	"./realname.svg": "9723",
	"./receberbox.svg": "b101",
	"./saveImage.svg": "1cd8",
	"./share-logo.svg": "52c6",
	"./sprite.svg": "cb7e",
	"./square-one.svg": "82e5",
	"./square-two.svg": "7d9d",
	"./stopPlay.svg": "9c43",
	"./svg.svg": "89b1",
	"./vs_logo.svg": "ec63"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";